import { CLIENT_CONTRACT, CLIENT_CONTRACT_HEADER, clientCompatibilitySchema } from '@speaking-coach/shared-types/src/client-compatibility.js';
/** App-owned public policy store. No identity, business data or second transport. */
export function createClientCompatibility() {
    let policy = null;
    const listeners = new Set();
    const observe = (value) => {
        const result = clientCompatibilitySchema.safeParse(value);
        if (!result.success || (policy && result.data.revision < policy.revision))
            return;
        const next = result.data;
        if (policy?.revision === next.revision) {
            // Equal-revision disagreement can tighten, never clear a confirmed rejection.
            next.supported = policy.supported.filter(contract => next.supported.includes(contract));
        }
        if (JSON.stringify(next) === JSON.stringify(policy))
            return;
        policy = next;
        listeners.forEach(listener => listener());
    };
    return {
        observe,
        getSnapshot: () => policy,
        required: () => policy !== null && !policy.supported.includes(CLIENT_CONTRACT),
        subscribe(listener) { listeners.add(listener); return () => { listeners.delete(listener); }; },
        headers(init) {
            const headers = new Headers(init);
            headers.set(CLIENT_CONTRACT_HEADER, String(CLIENT_CONTRACT));
            return headers;
        },
        async receive(response) {
            if (response.status !== 426)
                return;
            try {
                const body = await response.clone().json();
                if (body && typeof body === 'object' && 'detail' in body && body.detail && typeof body.detail === 'object' &&
                    'code' in body.detail && body.detail.code === 'client_update_required' && 'clientCompatibility' in body.detail)
                    observe(body.detail.clientCompatibility);
            }
            catch { /* A generic proxy failure is not confirmed incompatibility. */ }
        },
    };
}
//# sourceMappingURL=client-compatibility.js.map